import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import {
    IChecklist2ForReport,
    IChecklist2ReportAnswer,
} from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';

export interface IDeviationsListWrapperDialogData {
    availableChecklists: IChecklist2ForReport[];
    answerDetails: IChecklist2ReportAnswer[];
}

@Component({
    selector: 'fi-deviation-checklist-details-table-wrapper-dialog',
    template: `
        <fi-deviation-checklist-details-table-wrapper
            [answerDetails]="data.answerDetails"
            [availableChecklists]="data.availableChecklists"
            (conversationOpened)="dialogRef.close()"
        >
        </fi-deviation-checklist-details-table-wrapper>
    `,
    styleUrls: ['./deviation-checklist-details-table-wrapper-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-deviation-checklist-details-table-wrapper-dialog' },
    standalone: false,
})
export class FiDeviationChecklistDetailsTableWrapperDialogComponent extends FiDialogsContentBase<
    IDeviationsListWrapperDialogData,
    void
> {}
